import {
  GET_ERRORS,
  GET_LOAD_DATA_ERRORS,
  PIN_SEND,
  UNSUBSCRIBE_CANCEL,
} from '../constants/actionTypes';

export const resetError = () => (dispatch) => {
  dispatch({ type: GET_ERRORS, payload: null });
  dispatch({ type: PIN_SEND, payload: null });
};

export const resetDataError = () => (dispatch) => {
  dispatch({ type: GET_LOAD_DATA_ERRORS, payload: null });
};

export const resetUnsubscribe = (data) => (dispatch) => {
  dispatch({ type: UNSUBSCRIBE_CANCEL, payload: data });
};
